// tog'a #1952 (2026-09-14): «minus faqat qarzlarda» — qoldiq, son, mavjud miqdor ko'rsatishda 0 dan past bo'lmaydi.
// Manfiy qoldiq faqat ma'lumot siljishida chiqadi; taqqoslash/rang uchun xom qiymatni ishlating, ko'rsatish uchun nonNeg.
export function nonNeg(v: any): number {
  const n = Number(v)
  return Number.isFinite(n) && n > 0 ? n : 0
}
